import posthog from 'posthog-js';

class PostHogService {
  private static instance: PostHogService;
  private initialized: boolean = false;
  private identified: boolean = false;

  private constructor() {}

  static getInstance(): PostHogService {
    if (!PostHogService.instance) {
      PostHogService.instance = new PostHogService();
    }
    return PostHogService.instance;
  }

  init() {
    if (
      typeof window !== 'undefined' &&
      process.env.NEXT_PUBLIC_POSTHOG_KEY &&
      (process.env.NODE_ENV === 'production' || process.env.NEXT_PUBLIC_POSTHOG_ENABLED_FOR_DEBUG) &&
      !this.initialized
    ) {
      posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
        api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://eu.i.posthog.com',
        loaded: (posthog) => {
          if (process.env.NODE_ENV === 'development') posthog.debug();
        },
      });
      this.initialized = true;
    }
  }

  identify(userId: string, properties?: Record<string, any>) {
    if (process.env.NODE_ENV === 'production' || process.env.NEXT_PUBLIC_POSTHOG_ENABLED_FOR_DEBUG && !this.identified) {
      try {
        posthog.identify(userId, properties);
        this.identified = true;
      } catch (error) {
        console.error('Error identifying user in PostHog:', error);
      }
    }
  }

  reset(resetDeviceId: boolean = false) {
    if (process.env.NODE_ENV === 'production' || process.env.NEXT_PUBLIC_POSTHOG_ENABLED_FOR_DEBUG) {
      try {
        posthog.reset(resetDeviceId);
        this.identified = false;
      } catch (error) {
        console.error('Error resetting PostHog:', error);
      }
    }
  }

  getDistinctId(): string | null {
    if (process.env.NODE_ENV === 'production' || process.env.NEXT_PUBLIC_POSTHOG_ENABLED_FOR_DEBUG) {
      try {
        return posthog.get_distinct_id();
      } catch (error) {
        console.error('Error getting PostHog distinct ID:', error);
        return null;
      }
    }
    return null;
  }

  capture(eventName: string, payload?: Record<string, any>) {
    if (process.env.NODE_ENV === 'production' || process.env.NEXT_PUBLIC_POSTHOG_ENABLED_FOR_DEBUG) {
      try {
        posthog.capture(eventName, payload);
      } catch (error) {
        console.error('Error capturing PostHog event:', error);
      }
    }
  }
}

export const posthogService = PostHogService.getInstance(); 